import { usersColumns } from '../../constant'
import { DataTable } from '@/components/common/data-table/data-table'
import { useDatabaseContext } from '../../context'

export const UserDataTable = ({
  setIsDataChange,
}: {
  setIsDataChange: (isDataChange: boolean) => void
}) => {
  const { usersData, usersPagination, setUsersPagination } =
    useDatabaseContext()

  return (
    <>
      <div className="absolute inset-0 bottom-14 overflow-auto">
        <DataTable
          columns={usersColumns}
          data={usersData}
          className="-mt-[0.5px] border-b dark:border-gray-800 overflow-auto"
          tableHeadClassName="h-10 border-r dark:border-[#232323] border-[#232323] text-center bg-[rgba(21,241,253,0.06)]"
          tableCellClassName="py-3 border-r dark:border-[#232323] dark:text-gray-200 max-w-[200px] truncate text-center"
          // tableHeaderClassName="bg-gray-50 dark:bg-gray-800 dark:text-gray-200"
        />
      </div>
      {/* {usersPagination?.total > 0 && (
        <PaginationView
          pagination={usersPagination}
          onPrevPage={() =>
            setUsersPagination(
              (prev) => new Pagination(prev.page - 1, prev.perPage, prev.total),
            )
          }
          onNextPage={() =>
            setUsersPagination(
              (prev) => new Pagination(prev.page + 1, prev.perPage, prev.total),
            )
          }
        />
      )} */}
    </>
  )
}
